import type { SxProps, Theme } from "@mui/material";

export const ADMIN_CONTENT_MAX_WIDTH = 1280;

export const adminPageRoot: SxProps<Theme> = {
  width: "100%",
  boxSizing: "border-box",
};

export const adminSurface: SxProps<Theme> = {
  overflow: "hidden",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 2,
  bgcolor: "background.paper",
  boxShadow:
    "0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04)",
};

export const adminTableHeadRow: SxProps<Theme> = {
  bgcolor: "grey.50",
  "& .MuiTableCell-head": {
    fontWeight: 600,
    fontSize: "0.8125rem",
    color: "text.secondary",
    py: 1.5,
    whiteSpace: "nowrap",
    borderBottom: "1px solid",
    borderColor: "divider",
  },
};

export const adminTableBodyRow: SxProps<Theme> = {
  transition: "background-color 0.15s ease",
  "&:hover": {
    bgcolor: "action.hover",
  },
  "& .MuiTableCell-root": {
    py: 1.75,
    fontSize: "0.875rem",
    borderBottom: "1px solid",
    borderColor: "divider",
  },
};

/** Alternating row background for readable data tables */
export function adminTableRowSx(index: number): SxProps<Theme> {
  return {
    ...adminTableBodyRow,
    bgcolor: index % 2 === 1 ? "grey.50" : "background.paper",
  };
}

export const adminMobileCard: SxProps<Theme> = {
  p: 2,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
  cursor: "pointer",
  transition: "box-shadow 0.15s ease, border-color 0.15s ease",
  "&:hover": {
    borderColor: "primary.light",
    boxShadow: "0 4px 12px rgba(25, 118, 210, 0.08)",
  },
  "&:active": {
    bgcolor: "action.selected",
  },
};

export const adminFilterGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(auto-fill, minmax(168px, 1fr))",
  },
  gap: 1.5,
  width: "100%",
};

export const adminKpiCard: SxProps<Theme> = {
  height: "100%",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 2,
  bgcolor: "background.paper",
};
